import { ACCESS_TOKEN } from './auth';
import { saveAs } from 'file-saver';
import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import getStorageWithExpiry from './getStorageWithExpiry';

const downloadTorFile = async (url: string, fileName?: Maybe<string>) => {
    const token = getStorageWithExpiry('local')?.getItem(ACCESS_TOKEN);

    const result = await fetch(url, {
        headers: {
            authorization: `Bearer ${token}`,
        },
    });

    if (result.ok) {
        const blob = await result.blob();
        saveAs(blob, fileName ?? undefined);
    }
};

export default downloadTorFile;
